export type Theme = "device" | "white" | "light" | "dark";

export function useTheme() {
  const getTheme = (): Theme =>
    (localStorage.getItem("theme") as Theme) || "device";

  const applyTheme = (theme: Theme): Theme => {
    // Keep the existing html data-theme contract for styles/components
    // that already depend on it.
    document.documentElement.setAttribute("data-theme", theme);

    // Keep the canonical body-class theme system in sync with data-theme.
    // index.css defines the actual --card/--bg/--text theme variables on
    // body.white/body.light/body.dark/body.device.
    document.body.classList.remove(
      "device",
      "white",
      "light",
      "dark",
    );

    document.body.classList.add(theme);

    return theme;
  };

  const toggleTheme = (): Theme => {
    const themes: Theme[] = ["device", "white", "light", "dark"];
    const current = getTheme();
    const next = themes[(themes.indexOf(current) + 1) % themes.length];

    localStorage.setItem("theme", next);
    return applyTheme(next);
  };

  return {
    theme: getTheme(),
    toggleTheme,
    applyTheme,
  };
}
